import EventV2NavBar from "./V2/EventV2NavBar";

const Header = () => <EventV2NavBar />;

export default Header;
